import { render, staticRenderFns } from "./VeJwPyfaRecycleBin.vue?vue&type=template&id=29ecf864"
import script from "./VeJwPyfaRecycleBin.vue?vue&type=script&lang=js"
export * from "./VeJwPyfaRecycleBin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports